// extracted by mini-css-extract-plugin
export default {"rotate":"PopupContainer_rotate__G3AW4","animation":"PopupContainer_animation__fKAl6"};